import React, { useEffect, useReducer, useRef } from 'react';
import { useHover, useFocus, useActive } from 'react-native-web-hooks';
import { Stack, XStack, SizableText, useTheme } from 'tamagui';
import { Flex } from 'components/base/General';
import { Image } from 'react-native';
import Hamburger from 'resources/img/icons/hamburger.png';
import { openSideBar } from 'reducers/slices/sidebar';
import { TouchableOpacity } from 'components/utility/Buttons';
import { useWindowDimensions } from 'react-native';
import { useColorModeValue } from 'utils/hooks';
import Logo from 'components/utility/Logo';
import SignIn from 'components/utility/SignIn';
import { Link } from 'solito/link';
import { ChevronDownIcon } from 'app/components/utility/SVGIcons';
import { useSelector, useDispatch } from 'react-redux';
const DropdownMenu = props => {
  const sidebar = useSelector(state => state.sidebar);
  const dispatch = useDispatch();
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  const windowVals = useWindowDimensions();
  const toggleSidebar = () => {
    dispatch(openSideBar(!sidebar));
  };
  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener('resize', resize);
    }
    return () => {
      if (window.removeEventListener) {
        window.removeEventListener('resize', resize);
      }
    };
  }, []);
  const resize = () => {
    if (windowVals.width > 768) {
      dispatch(openSideBar(false));
    }
    forceUpdate();
  };
  if (windowVals.width > 768) {
    return /*#__PURE__*/React.createElement(XStack, {
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
      bg: "white",
      style: props.menu,
      px: 0,
      $xl: {
        px: 40
      }
    }, /*#__PURE__*/React.createElement(XStack, {
      flex: 1
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, /*#__PURE__*/React.createElement(Logo, null))), /*#__PURE__*/React.createElement(XStack, {
      flex: 2.5,
      $sm: {
        flex: 2.5
      },
      $md: {
        flex: 2.25
      },
      $lg: {
        flex: 2.25
      },
      $xl: {
        flex: 1
      }
    }, props.items.map((item, index) => /*#__PURE__*/React.createElement(DropdownItem, {
      name: item.name,
      item: item,
      key: index,
      containerStyle: props.itemStyles,
      style: props.itemStyles,
      props: props,
      href: item.link
    }))), /*#__PURE__*/React.createElement(SignIn, null));
  } else if (windowVals.width <= 768) {
    return /*#__PURE__*/React.createElement(Stack, {
      bg: "white",
      height: 50,
      px: 5,
      zIndex: 999,
      justifyContent: "center"
    }, /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: toggleSidebar
    }, /*#__PURE__*/React.createElement(Image, {
      source: Hamburger,
      style: {
        height: 25,
        width: 25
      },
      alt: "Hamburger menu"
    })));
  }
};
const DropdownItem = ({
  props,
  item,
  href = '/',
  name
}) => {
  const ref = useRef(null);
  const isHovered = useHover(ref);
  const isFocused = useFocus(ref);
  const isActive = useActive(ref);
  let color = isHovered ? '#c9150f' : '#000';
  return /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    opacity: 1,
    zIndex: 999,
    ref: ref
  }, /*#__PURE__*/React.createElement(Stack, {
    py: 10,
    draggable: false,
    tabIndex: 0,
    style: {
      bottom: '100',
      height: 80,
      justifyContent: 'center',
      alignItems: 'center',
      opacity: 1,
      zIndex: 999,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: !item.children ? href : ''
  }, /*#__PURE__*/React.createElement(SizableText, {
    fontWeight: "bold",
    alignItems: "center",
    display: "flex",
    fontSize: "$md",
    color: color,
    hoverStyle: {
      color: '#c9150f'
    },
    focusStyle: {
      color: '#c9150f'
    },
    pressStyle: {
      color: '#c9150f'
    }
  }, name + ' ', item.children ? /*#__PURE__*/React.createElement(ChevronDownIcon, {
    color: color,
    size: 28
  }) : null))), /*#__PURE__*/React.createElement(Stack, {
    flex: 1
  }, isHovered && item.children ? item.children.map((child, index) => /*#__PURE__*/React.createElement(DropdownItemChild, {
    child: child,
    index: index,
    key: index,
    hovered: isHovered,
    props: props,
    href: child.link
  })) : null));
};
const DropdownItemChild = ({
  props,
  child,
  index,
  hovered,
  href = '/'
}) => {
  const theme = useTheme();
  let borderColor = useColorModeValue('#eee', 'gray');
  const backgroundColor = useColorModeValue('#FFF', '#404040');
  return /*#__PURE__*/React.createElement(Link, {
    href: href
  }, /*#__PURE__*/React.createElement(Stack, {
    animation: "easeFadeIn",
    textDecoration: "none",
    top: props.childSize * index,
    opacity: 1,
    bg: backgroundColor,
    cursor: "pointer",
    borderBottomColor: borderColor,
    borderTopColor: borderColor,
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    position: "absolute",
    height: 35,
    width: 210,
    paddingLeft: 10,
    paddingRight: 10,
    zIndex: 9999,
    justifyContent: "center",
    alignItems: "center",
    borderBottomWidth: 1,
    borderTopWidth: 1,
    draggable: false,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(SizableText, {
    width: "100%",
    fontSize: "$sm",
    fontWeight: "bold",
    cursor: "pointer",
    textAlign: "center",
    hoverStyle: {
      color: '#c9150f'
    },
    focusStyle: {
      color: '#c9150f'
    },
    pressStyle: {
      color: '#c9150f'
    },
    color: theme.dropdownMenu
  }, child.name)));
};
export default DropdownMenu;